<template>
    <div>
      <el-card class="box-card" style="margin: 30px; padding: 20px;">
        <div style="display: flex;">
          <div style="width: 420px;">
            <div style="min-height: 800px; border-radius: 10px; border: 1px solid #ccc;">
              <el-carousel height="200px" indicator-position="outside">
                <el-carousel-item v-for="item in branddata" :key="item">
                  <div @click="showlink(item)" style="height:100%; width:100%;">
                    <el-image
                      :src="item.adurl"
                      style="height:100%; width:100%;"
                      fit="cover"></el-image>
                  </div>
                </el-carousel-item>
              </el-carousel>
              <div style="margin: 10px; padding: 15px; border: 1px dotted #d9d9d9; border-radius: 6px;">
                <el-row :gutter="20">
                  <el-col :span="6" v-for="item in kjrkdata" :key="item">
                    <div style="display: flex; margin-top: 10px; flex-direction: column; align-items: center; justify-content: center;">
                      <el-image
                        :src="item.scurl"
                        style="width: 64px;height: 64px;display: block;border: 1px dashed #d9d9d9; border-radius: 6px;"
                        fit="cover"></el-image>
                      <div style="margin-top: 10px;">{{item.scname}}</div>
                    </div>
                  </el-col>
                </el-row>
              </div>
              <div style="margin: 10px; padding: 15px; border: 1px dotted #d9d9d9; border-radius: 6px;">
                <el-row :gutter="20">
                  <el-col :span="12" v-for="item in tjspdata" :key="item">
                    <div style="display: flex; margin-top: 10px; flex-direction: column; align-items: center; justify-content: center;">
                      <el-image
                        :src="item.img_url"
                        style="width: 128px;height: 128px;display: block;border: 1px dashed #d9d9d9; border-radius: 6px;"
                        fit="cover"></el-image>
                      <div style="margin-top: 10px; width: 120px; height: 60px; text-align: center;">{{item.name}}</div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
          <div style="flex: 1;margin: 0 20px 0 40px;">
            <div style="padding: 0 0 20px 0;">
              <el-button type="primary" icon="el-icon-plus" @click="addtjsp">添加推荐商品</el-button>
            </div>
            <div style="padding: 40px; border: 1px solid #d9d9d9; display: flex;justify-content: center;">
              <el-table
                stripe
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}"
                :data="tjspdata"
                ref="multipleTable">
                <el-table-column
                  prop="name"
                  label="推荐商品名称">
                </el-table-column>
                <el-table-column
                  prop="recindex"
                  label="推荐序号">
                </el-table-column>
                <el-table-column
                  label="操作"
                  width="120px"
                >
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" content="编辑推荐商品" placement="top-start">
                      <i class="fa el-icon-edit-outline fa-lg opicon curpointer" v-on:click="edittjgoods(scope.$index, tjspdata)"></i>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="修改次序" placement="top-start">
                      <i style="margin-left: 15px;" class="fa el-icon-sort fa-lg ciicon curpointer" v-on:click="changeindex(scope.$index, tjspdata)"></i>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="删除推荐商品" placement="top-start">
                      <i style="margin-left: 15px; color: darkred" class="fa fa-trash-o ciicon fa-lg curpointer" v-on:click="deltjgoods(scope.$index, tjspdata)"></i>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <el-dialog title="资料信息" :visible.sync="vis_addtjgoodspanel" @open="showtjgoodsdialog" ref="tjgoodsdialog">
              <el-form  label-width="100px">
                <div style="display: flex;flex-flow: row wrap;">
                  <el-form-item label="是否推荐" style="margin-right: 20px;">
                    <el-select v-model="ifrecinfo" filterable placeholder="请选择是否推荐">
                      <el-option
                        v-for="item in ifrecdata"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="推荐序号">
                    <el-input v-model="tjindex" placeholder="请输入推荐序号"></el-input>
                  </el-form-item>
                </div>
              </el-form>
              <div style="display: flex;flex-flow: row wrap;">
                <el-table
                  fit
                  :header-cell-style="{'text-align':'center'}"
                  :cell-style="{'text-align':'center'}"
                  ref="mytjgoodstbt1"
                  :data="cusgoodsdata"
                >
                  <el-table-column
                    type="selection"
                    width="55">
                  </el-table-column>
                  <el-table-column
                    width="80"
                    prop="id"
                    label="产品ID"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="name"
                    label="产品名称">
                  </el-table-column>
                </el-table>
              </div>
              <div class="showpcinfo" style="margin-top: 15px">
                <el-button type="success" icon="el-icon-edit-outline" @click="addtjgood">保存推荐商品</el-button>
              </div>
            </el-dialog>
          </div>
        </div>
      </el-card>
    </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  import UpLoadFile from '../upload/UpLoadFile'
  Vue.prototype.$http = axios
  var that
  export default {
    name: 'GoodsTJ',
    components: {
      UpLoadFile
    },
    data () {
      return {
        branddata: [],
        kjrkdata: [],
        tjspdata: [],
        cusgoodsdata: [],
        ifrecinfo: '1',
        ifrecdata: [{
          value: '1',
          label: '推荐'
        }],
        vis_addtjgoodspanel: false,
        ifnewtjgoods:false,
        edittjgoodsdata: '',
        tjindex: '',
        khid: ''
      }
    },
    mounted () {
      that = this
      var v = getCookie('cusid')
      this.khid = v
      that.$options.methods.getgoods()
      that.querykjrk()
      that.querybrand()
      that.querygtj()
    },
    methods: {
      querybrand () {
        that = this
        if (that.khid === null) {
          that.$message({
            type: 'info',
            message: 'Cookie已失效，请重新登录!'
          })
          that.$router.push({path: '/'})
        } else {
          var qstr = {
            whereinfo: " ownphone ='" + localStorage.getItem('username') + "'",
            limit: '',
            sortinfo: ''
          }
          that.$http({
            url: 'https://ecommapi.sqnetsoft.cn/querylbi',
            method: 'post',
            data: qstr,
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              if (res.data.length > 0) {
                that.branddata = res.data
              } else {
                that.branddata = []
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
        }
      },
      querykjrk () {
        that = this
        if (that.khid === null) {
          that.$message({
            type: 'info',
            message: 'Cookie已失效，请重新登录!'
          })
          that.$router.push({path: '/'})
        } else {
          var qstr = {
            whereinfo: " ownphone ='" + localStorage.getItem('username') + "'",
            limit: '',
            sortinfo: ''
          }
          that.$http({
            url: 'https://ecommapi.sqnetsoft.cn/querykjrk',
            method: 'post',
            data: qstr,
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              if (res.data.length > 0) {
                that.kjrkdata = res.data
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
        }
      },
      /* 获取商品推荐 */
      querygtj () {
        that = this
        if (that.khid === null) {
          that.$message({
            type: 'info',
            message: 'Cookie已失效，请重新登录!'
          })
          that.$router.push({path: '/'})
        } else {
          var qstr = {
            whereinfo: " ownphone ='" + localStorage.getItem('username') + "'",
            limit: '',
            sortinfo: ' order by recindex'
          }
          that.$http({
            url: 'https://ecommapi.sqnetsoft.cn/querygrecommend',
            method: 'post',
            data: qstr,
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              if (res.data.length > 0) {
                that.tjspdata = res.data
              } else {
                that.tjspdata = []
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
        }
      },
      getgoods () {
        var qstr = {
          whereinfo: " ownphone ='" + localStorage.getItem('username') + "'",
          limit: '',
          sortinfo: ' order by goodsindex'
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/queryginfo',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.length > 0) {
              that.cusgoodsdata = res.data
            } else {
              that.cusgoodsdata = []
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      addtjgood () {
        console.log()
        var addgood = []
        if (this.ifnewtjgoods) {
          for (var index in this.$refs.mytjgoodstbt1.selection) {
            var tmpdata = {
              id: '',
              goodsid: this.$refs.mytjgoodstbt1.selection[index].id.toString(),
              ifrec: that.ifrecinfo.toString(),
              recindex: that.tjindex.toString(),
              cusid: that.khid.toString(),
              ownphone: localStorage.getItem('username')
            }
            addgood.push(tmpdata)
          }
        } else {
          var tmpdata1 = {
            id: this.edittjgoodsdata.id.toString(),
            goodsid: this.edittjgoodsdata.goodsid.toString(),
            ifrec: that.ifrecinfo.toString(),
            recindex: that.tjindex.toString(),
            cusid: that.khid.toString(),
            ownphone: localStorage.getItem('username')
          }
          addgood.push(tmpdata1)
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/paddgrecommend',
          method: 'post',
          data: addgood,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.result === 'success') {
              that.$message({
                type: 'success',
                message: '保存完毕'
              })
              that.querygtj()
            } else {
              that.$message({
                type: 'error',
                message: '保存失败'
              })
            }
          })
          .catch(function (error) {
            that.$message({
              type: 'error',
              message: '保存失败'
            })
            console.log('error' + error)
          })
      },
      showtjgoodsdialog () {
        console.log(this)
        console.log(this.$refs.mytjgoodstbt1)
      },
      addtjsp () {
        this.vis_addtjgoodspanel = true
        this.ifnewtjgoods = true
        setTimeout(() => {
          this.$refs.mytjgoodstbt1.clearSelection()
        }, 0)
      },
      querytjsp () {
        that = this
        if (that.khid === null) {
          that.$message({
            type: 'info',
            message: 'Cookie已失效，请重新登录!'
          })
          that.$router.push({path: '/'})
        } else {
          var qstr = 'cusid =' + that.khid
          that.$http({
            url: 'https://ecommapi.sqnetsoft.cn/layout/getgr',
            method: 'post',
            data: {
              whereinfo: {String: qstr, Valid: true},
              sorinfo: {String: ' order by recindex', Valid: true}
            },
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              if (res.data.success) {
                console.log(JSON.parse(res.data.data))
                that.tjspdata = JSON.parse(res.data.data)
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
        }
      },
      edittjgoods (index, data) {
        var curselectdata = data[index]
        this.ifnewtjgoods = false
        this.vis_addtjgoodspanel = true
        console.log(curselectdata)
        console.log(this.cusgoodsdata)
        this.ifrecinfo = curselectdata.ifrec.toString()
        this.tjindex = curselectdata.recindex
        var dataindex = that.cusgoodsdata.findIndex(d => d.id === curselectdata.goodsid)
        console.log(that.cusgoodsdata[dataindex])
        this.edittjgoodsdata = curselectdata
        setTimeout(() => {
          this.$refs.mytjgoodstbt1.clearSelection()
          this.$refs.mytjgoodstbt1.toggleRowSelection(that.cusgoodsdata[dataindex])
        }, 0)
      },
      querytjspex: function () {
        var qstr = 'cusid =' + that.khid
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/layout/getgr',
          method: 'post',
          data: {
            whereinfo: {String: qstr, Valid: true},
            sorinfo: {String: ' order by recindex', Valid: true}
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.success) {
              console.log(JSON.parse(res.data.data))
              that.tjspdata = JSON.parse(res.data.data)
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      changeindex (index, data) {
        var seldata = data[index]
        console.log(seldata)
        this.$prompt('请输入显示次序（数字）', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(({ value }) => {
          var updata = {
            goodsid: seldata.goodsid.toString(),
            recindex: value.toString(),
            ownphone: localStorage.getItem('username')
          }
          that.$http({
            url: 'https://ecommapi.sqnetsoft.cn/upgrecommendindex',
            method: 'post',
            data: updata,
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              console.log(res)
              if (res.data.result === 'success') {
                that.querygtj()
                that.$message({
                  type: 'success',
                  message: '已更新次序'
                })
              } else {

              }
            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消次序变更'
          })
        })
      },
      deltjgoods (index, data) {
        var curselectdata = data[index]
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/delgrecommend',
          method: 'post',
          data: {
            id: curselectdata.id.toString()
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.result === 'success') {
              that.$message({
                type: 'success',
                message: '删除成功!'
              })
              that.querygtj()
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      }
    }
  }
  function getCookie (name) {
    var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
    return v ? v[2] : null
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/control/GoodsTJ.vue